import React from 'react';
import { makeStyles } from 'tss-react/mui';
import { Box, Grid } from '@mui/material';

const useStyles = makeStyles()(theme => ({
  formStyle: {
    borderRadius: '4px',
    border: `1px solid ${theme.palette.system.lightGrey}`,
    opacity: 1,
    background: `${theme.palette.system.lightGrey2} 0% 0% no-repeat padding-box`,
    paddingRight: '12px',
    marginBottom: '12px',
  },
  containerStyle: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  mainBodyContainer: {
    flexGrow: 1,
    flexDirection: 'column',
  },
  headerContainer: {
    fontSize: `16px !important`,
    margin: '10px 0px 8px 12px',
    fontWeight: 'bold',
  },
  contentContainer: {
    flexDirection: 'row',
    flexGrow: 1,
    border: '1px solid #ccc',
    padding: '12px',
    margin: '10px',
    marginRight: '0px',
    marginTop: '0px',
    backgroundColor: theme.palette.common.white,
    borderRadius: '4px',
  },
}));

export const WrapperComponentWithSubSections = ({
  icon,
  title,
  childrenOne,
  childrenTwo,
}: {
  title: string;
  childrenOne?;
  childrenTwo?;
  icon?;
}) => {
  const { classes } = useStyles();

  return (
    <form className={classes.formStyle}>
      <Grid container classes={{ root: classes.containerStyle }}>
        <Grid container item classes={{ root: classes.mainBodyContainer }}>
          <Grid item classes={{ root: classes.headerContainer }}>
            <Box sx={{ display: 'flex', justifyContent: 'space-between' }}>
              {title} {icon}
            </Box>
          </Grid>
          <Grid sx={{ display: 'flex', justifyContent: 'space-between' }}>
            <Grid container item classes={{ root: classes.contentContainer }}>
              <Grid container>
                <Grid item spacing={1} sx={{ display: 'contents' }}>
                  {childrenOne}
                </Grid>
              </Grid>
            </Grid>
            <Grid container item classes={{ root: classes.contentContainer }}>
              <Grid container>
                <Grid item spacing={1} sx={{ display: 'contents' }}>
                  {childrenTwo}
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </form>
  );
};
